import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { PageContainer, TextBlock } from '../../components/StyledElements';
import { createOrder } from '../../actions/order';
import { getRolesAsBoolean, getMemberFromOrg } from '../../utils/userRoleHelpers';
import { RentalUserVariant, GenericVariant } from './AccountLicenseVariants';
import isEmpty from 'lodash/isEmpty';

const AccountLicense = ({ currentOrder, organization, user, license }) => {
  const relevantMember = getMemberFromOrg(organization, user);
  const { isOwner, isRentalUser, isGenericUser } = getRolesAsBoolean(relevantMember);
  const isExternalUser = user.isExternalUser;
  const hasOrder = !isEmpty(currentOrder);
  const displayGenericVariant = hasOrder && (isGenericUser || isOwner) && !isExternalUser;

  return (
    <>
      <Helmet>
        <title>Meine Lizenz</title>
      </Helmet>
      <PageContainer narrow={!isExternalUser}>
        {displayGenericVariant && (
          <GenericVariant currentOrder={currentOrder} isGenericUser={isGenericUser} isOwner={isOwner} license={license} />
        )}
        {isRentalUser && <RentalUserVariant relevantMember={relevantMember} />}
        {isExternalUser && (
          <TextBlock color={'#f26521'} centered fontSize={1.5} mt={10} mb={10}>
            Haben Sie Fragen zu Ihrer Lizenz?<br/>
            Dann melden Sie sich gern bei unserem Kundenservice unter <a href='mailto:service@onilo.de'>service@onilo.de</a>.
          </TextBlock>
        )}
      </PageContainer>
    </>
  );
};

AccountLicense.propTypes = {
  user: PropTypes.object,
  currentOrder: PropTypes.object.isRequired,
  license: PropTypes.object.isRequired,
  createOrder: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired,
};

export default connect(null, { createOrder })(AccountLicense);
